// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalHeader_container__2VGBa","close":"ModalHeader_close__2KD0F"};